import { APIClient } from "api/api_helper";
import { MasterCheckList_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const masterchecklistservice = {

    // -------------------------------------------------------------
    // SELECT ALL ICF QUESTIONS
    // -------------------------------------------------------------
    getSelectAllData: (params: any) => {
        const payload = {
            searchtext: params.searchtext || null,
            status: "A",
            currentpage: params.currentpage,
            pagesize: params.pagesize,
            ispagination: params.ispagination ?? true,
            checklisttype: params.checklisttype || null,
            checklistcategory: params.checklistcategory || null,
        };

        return api.create(MasterCheckList_API.MasterCheckList_API + "SelectAll", payload);
    },

    // -------------------------------------------------------------
    // SELECT ALL CHECKLIST TYPES
    // -------------------------------------------------------------
    getChecklistTypeSelectAllData: (params: any) => {
        const payload = {
            searchtext: params.searchtext || null,
            checklistcategory: params.checklistcategory || null,
            currentpage: params.currentpage || 1,
            pagesize: params.pagesize || 10,
        };

        return api.create(MasterCheckList_API.ChecklistType_API + "SelectAll", payload);
    },

    // -------------------------------------------------------------
    // INSERT ICF QUESTION
    // -------------------------------------------------------------
    insertData: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            question: payload_data.question,
            answeroption: payload_data.answeroption,
            isrequired: payload_data.isrequired,
            checklisttype: payload_data.checklisttype,
            createdby: user.userid,
        };

        return api.create(MasterCheckList_API.MasterCheckList_API + "Insert", payload);
    },

    // -------------------------------------------------------------
    // UPDATE ICF QUESTION
    // -------------------------------------------------------------
    updateData: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            masterchecklistid: payload_data.masterchecklistid,
            question: payload_data.question,
            answeroption: payload_data.answeroption,
            isrequired: payload_data.isrequired,
            checklisttype: payload_data.checklisttype,
            updatedby: user.userid,
            updatereason: payload_data.updatereason,
        };

        return api.create(MasterCheckList_API.MasterCheckList_API + "Update", payload);
    },

    // -------------------------------------------------------------
    // DELETE ICF QUESTION
    // -------------------------------------------------------------
    deleteData: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            masterchecklistid: payload_data.masterchecklistid,
            updatedby: user.userid,
            updatereason: payload_data.updatereason,
        };

        return api.create(MasterCheckList_API.MasterCheckList_API + "Delete", payload);
    },

    // -------------------------------------------------------------
    // ASSIGN CATEGORY 
    // -------------------------------------------------------------
    assignCategory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            checklisttype: payload_data.checklisttype,
            checklistcategory: payload_data.checklistcategory,
            categoryassignedby: user?.userid,
        };

        return api.create(MasterCheckList_API.MasterCheckList_API + "AssignCategoryInsert", payload);
    },
    
    updateCategory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            checklisttype: payload_data.checklisttype,
            checklistcategory: payload_data.checklistcategory,
            categoryupdatedby: user?.userid,
            categoryupdatereason: payload_data.categoryupdatereason || payload_data.updatereason,
        };

        return api.create(MasterCheckList_API.MasterCheckList_API + "AssignCategoryUpdate", payload);
    },

    // -------------------------------------------------------------
    // UPDATE DISPLAY ORDER
    // -------------------------------------------------------------
    updateDisplayOrder: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            displayorderjson: payload_data.displayorderjson,
            updatedby: user?.userid,
        };
        return api.create(MasterCheckList_API.MasterCheckList_API + "UpdateOrder", payload);
    },
};